<template>
  <div>
    <HttpContentView :endpoint="utilities.path('communities/@/modules/automation/templates', communityId)" @response="templates = $event">
      <template v-slot:content>
        <div v-if="templates && templates.length > 0">
          <InputView type="text" v-model:value="filterQuery" :placeholder="translate('filter')" class="mb-4"/>
          <div class="row g-4">
            <div class="col-12 col-lg-6" v-for="(template, index) in filteredTemplates" :key="index">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex flex-column g-3">
                    <div>
                      <h4 class="mb-2">{{ template.title }}</h4>
                      <div class="text-muted small">{{ template.description }}</div>
                    </div>
                    <div class="d-flex align-items-center g-2">
                      <TooltipView>
                        <template v-slot:target>
                          <div class="bg-secondary d-flex align-items-center justify-content-center shadow-sm" style="border-radius: 0.8rem; width: 40px; height: 40px; padding: 1.2rem; font-size: 1.1em">
                            <i class="fa-fw" :class="template.trigger.icon"></i>
                          </div>
                        </template>
                        <template v-slot:body>
                          {{ template.trigger.title }}
                        </template>
                      </TooltipView>
                      <i class="fas fa-arrow-right"></i>
                      <div class="d-flex align-items-center flex-wrap g-0">
                        <div v-for="(action, index) in template.actions" :key="index">
                          <TooltipView>
                            <template v-slot:target>
                              <div class="bg-secondary d-flex align-items-center justify-content-center mx-1 my-1 shadow-sm" style="border-radius: 0.8rem; width: 40px; height: 40px; padding: 1.2rem; font-size: 1.1em">
                                <i class="fa-fw" :class="action.icon"></i>
                              </div>
                            </template>
                            <template v-slot:body>
                              {{ action.title }}
                            </template>
                          </TooltipView>
                        </div>
                      </div>
                    </div>
                    <div v-if="template.modules && template.modules.length > 0" class="d-flex align-items-center g-2">
                      <span class="rounded-3 bg-secondary p-1 border border-1" :class="module.enabled ? 'border-secondary' : 'border-warning'" v-for="module in template.modules" :key="module.key" style="word-break: keep-all; font-size: 0.8em">
                        <i :class="module.icon" class="fa-fw me-1"></i>
                        <span>{{ module.name }}</span>
                      </span>
                    </div>
                    <ButtonView type="soft" color="primary" class="w-100" :disabled="!template.available" @click="selectedTemplate = template">
                      {{ translate('use_template') }}
                    </ButtonView>
                    <div v-if="!template.available" class="text-muted text-center small">
                      {{ translate('automation.templates.unavailable.modulesDisabled') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="filteredTemplates.length === 0">

          </div>
        </div>
      </template>
    </HttpContentView>
    <ModalView :active="selectedTemplate !== undefined" @update:active="selectedTemplate = undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ selectedTemplate.title }}</h3>
          <ModalCloseButtonView @click="selectedTemplate = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <TemplateFormView :community-id="communityId" :template-key="selectedTemplate.key" @success="$router.push({ name: 'community.modules.automation.rules' })" @cancel="selectedTemplate = undefined"/>
      </template>
    </ModalView>
  </div>
</template>

<script>
import {ButtonView, InputView, HttpContentView, utilities, TooltipView, ModalView, ModalCloseButtonView} from "@niftybit/vue";
import TemplateFormView from "@/systems/modules/automation/templates/TemplateFormView.vue";

export default {
  name: "AutomationTemplatesView",
  components: {TemplateFormView, InputView, HttpContentView, ButtonView, TooltipView, ModalView, ModalCloseButtonView},
  props: {
    communityId: String,
    module: String
  },
  data() {
    return {
      templates: [],
      filterQuery: "",
      selectedTemplate: undefined
    }
  },
  computed: {
    utilities() {
      return utilities
    },
    filteredTemplates() {
      let list = this.filterQuery === "" ? this.templates : this.templates.filter(item => item.title.toLowerCase().includes(this.filterQuery.toLowerCase()) || item.description.toLowerCase().includes(this.filterQuery.toLowerCase()));
      if (this.module) list = list.filter(item => this.module === item.module?.key);
      list = list.sort((a, b) => !a.available && b.available ? 1 : a.available && !b.available ? -1 : 0);
      return list;
    },
  }
}
</script>

<style scoped>

</style>